<template>
  <div class="box">
      <div v-if="success=='true'">
          <div class="content">
              <div class="top-content">
                  <div class="clear">
                      <p class="tips">
                          <img src="../assets/img/correct.png" alt="" class="correct">
                          <span>订单提交成功，请您及时付款！</span>
                      </p>
                      <p class="order">订单号:{{orderId}}</p>
                      <p class="money">应付金额: <span>￥{{price}}</span>元</p>
                  </div>
                  <div class="count">
                      请您在提交订单后：<span class="countDown" v-if="requestBool">{{countNumber}}</span>内完成支付，超时后将自动取消订单
                  </div>
              </div>
              <div class="middle-content clear">
                  <div class="qr-code">
                      <p class="type">{{type=='wx'?'微信支付':'支付宝支付'}}</p>
                      <p class="code" v-if="type=='wx'"><img :src="`/api/common/pay/order/wxQrcode/${orderId}.png`" alt=""></p>
                      <p class="code" v-else><img :src="`/api/common/pay/order/aliQrcode/${orderId}.png`" alt=""></p>
                      <p class="scan clear"><img src="../assets/img/box.png" alt=""><span>请使用{{type=='wx'?'微信':'支付宝'}}扫一扫扫描二维码</span></p>
                  </div>
                  <div class="line"></div>
                  <div class="phone">
                      <img v-if="type=='wx'" src="https://pu-datacastle.oss-cn-qingdao.aliyuncs.com/master.third.source/dc_pay/iphone.png" alt="">
                      <img v-else src="https://pu-datacastle.oss-cn-qingdao.aliyuncs.com/master.third.source/dc_pay/alipay.png" alt="">
                  </div>
              </div>
              <div class="bottom-content" @click="goBack">
                  <img src="../assets/img/return.png" alt="">
                  选择其他支付方式
              </div>
          </div>
      </div>
      <div class="error-content" v-if="success=='false'">
          <div class="clear">
              <p class="error-tips">
                  <img src="../assets/img/warning.png" alt="">
                  <span>抱歉，参数错误不能完成支付！</span>
              </p>
          </div>
          <div class="btn clear">
              <p class="buy" @click="goBack">返回上一页</p>
          </div>
      </div>
  </div>
</template>

<script>



export default {
    name: 'pay',
    components: {},
    data () {
        return {
            countNumber:0,
            type:'',
            orderId:'',
            requestBool:false,
            site:'',
            price:'',
            payWay:'',
            url:'', //支付成功跳转
            indexUrl:'',  // 支付失败跳转首页
            success:'true'
        }
    },
    methods: {
        goBack() {
          this.$router.go(-1);
        },
        countdown(val) {
            let lastTime = val;
            this.timeInterval = window.setInterval(() => {
                lastTime = lastTime - 1000;
                if (this.common.lastTime(lastTime)) {
                    this.countNumber = this.common.lastTime(lastTime);
                } else {
                    clearInterval(this.timeInterval);
                    this.$router.push({path:'/payResult.html',query:{success:'time',indexUrl:this.indexUrl}});
                }
                this.requestBool = true;
            }, 1000)

        },
        getPayStatus(){
            const me = this;
            if(this.type == 'wx'){
                this.payWay = '微信支付';
            }else{
                this.payWay = '支付宝支付';
            }
            this.request('/common/pay/queryOrderPayStatus.json', {
                data:{
                    orderId: this.orderId,
                    payWay: this.payWay,
                }
            }).then((res) => {
                if(res.data.isPaid){
                    this.$router.push({path:'/payResult.html',query:{success:'true',url:this.url,price:this.price,orderId:this.orderId}})
                }else{
                   setTimeout(function () {
                       me.getPayStatus();
                   },3000)
                }
            })
        }
    },
    mounted:function () {
        if(this.$route.query.type){
           this.type = this.$route.query.type;
        }
        if(this.$route.query.orderId){
            this.orderId = this.$route.query.orderId;
        }
        if(this.$route.query.site){
            this.site = this.$route.query.site;
        }
        this.getPayStatus();
        this.request('/common/pay/getPayInfo.json', {
          data:{
              orderId: this.orderId,
              site: this.site,
          }
        }).then((res) => {
            if(res.data.payInfo){
                let info = JSON.parse(res.data.payInfo.orderInfo);
                this.price = info.orderPrice;
                this.url = res.data.payInfo.returnUrl;
                this.indexUrl =  res.data.payInfo.indexUrl;
                if(res.data.payInfo.leftMillisSecondsTime>0){
                    this.countdown(res.data.payInfo.leftMillisSecondsTime);
                }else{
                    this.$router.push({path:'/payResult.html',query:{success:'time',indexUrl:this.indexUrl}});
                }
            }else{
                this.success = 'false';
            }

        })
    },
    destroyed(){

    }

}
</script>
<style scoped lang="scss">
    .box{
        background: #fff;
        width: 1170px;
        margin: 0 auto;
        margin-top: 36px;
        .pay-title{
            font-size:18px;
            font-weight:600;
            color:rgba(48,50,51,1);
            padding: 40px 40px 16px 40px;
            border-bottom: 1px solid rgba(237,240,242,1);
            text-align: left;
        }
        .content{
            padding: 40px;
            .top-content{

                .correct{
                    width: 24px;
                    height: 24px;
                    vertical-align: middle;
                    margin-right: 8px;
                }
                p{
                    float: left;
                }
                p:last-child{
                    float: right;
                }
                .tips{
                    margin-right: 24px;
                    font-size:18px;
                    font-weight:500;
                    color:rgba(48,50,51,1);
                    line-height:26px;
                }
                .order{
                    font-size:14px;
                    font-weight:400;
                    color:rgba(144,149,153,1);
                    line-height:24px;
                }
                .money{
                    font-size:18px;
                    font-weight:500;
                    color:rgba(48,50,51,1);
                    line-height:26px;
                    span{
                        font-size:26px;
                        font-weight:normal;
                        color:rgba(245,34,45,1);
                        line-height:26px;
                        margin: 0 4px;
                    }
                }
                .count{
                    margin-top: 8px;
                    text-align: left;
                    margin-left: 32px;
                    font-size:14px;
                    font-weight:400;
                    color:rgba(144,149,153,1);
                    line-height:22px;
                    padding-bottom: 20px;
                    border-bottom:1px solid rgba(237,240,242,1);
                    .countDown{
                        color:#F5222D;
                        margin: 0 3px;
                    }
                }
            }
            .middle-content{
                padding-top: 40px;
                padding-left: 32px;
                .qr-code{
                    float: left;
                    width: 210px;
                    .type{
                        font-size:18px;
                        font-weight:500;
                        color:rgba(48,50,51,1);
                        line-height:28px;
                    }
                    .code{
                        margin: 16px 0 8px;
                        width:188px;
                        height:188px;
                        border:1px solid rgba(237,240,242,1);
                        padding: 10px;
                        img{
                            width: 190px;
                            height: 190px;
                        }
                    }
                    .scan{
                        font-size:14px;
                        font-weight:400;
                        color:rgba(144,149,153,1);
                        line-height:22px;
                        padding: 0 15px 0 31px;
                        img{
                            width: 28px;
                            height: 28px;
                            float: left;
                            margin-top: 8px;
                        }
                        span{
                            float: left;
                            width: 125px;
                            margin-left: 8px;
                            text-align: left;
                        }
                    }
                }
                .line{
                    float: left;
                    width:1px;
                    height:254px;
                    background:rgba(237,240,242,1);
                    margin: 0 88px;
                }
                .phone{
                    float: left;
                    img{
                        width: 198px;
                        height: 254px;
                    }
                }
            }
            .bottom-content{
                text-align: left;
                margin-top: 40px;
                font-size:14px;
                font-weight:500;
                color:rgba(58,163,255,1);
                line-height:22px;
                cursor: pointer;
                display: flex;
                align-items: center;
                img{
                    width: 24px;
                    height: 24px;
                    vertical-align: middle;
                    margin-right: 4px;
                }
            }
        }
        .error-content{
            padding: 20px 0 20px 32px;
            text-align: left;
            background: #fff;
            .error-tips{
                margin-right: 24px;
                font-size:18px;
                font-weight:500;
                color:rgba(48,50,51,1);
                line-height:26px;
                img{
                    width: 24px;
                    height: 24px;
                    vertical-align: middle;
                    margin-right: 8px;
                }
            }
            .btn{
                margin-top: 40px;
                margin-left: 32px;
                .buy{
                    width:88px;
                    height:32px;
                    background:rgba(58,163,255,1);
                    border-radius:4px;
                    text-align: center;
                    line-height: 32px;
                    font-size:14px;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    float: left;
                    margin-right: 24px;
                    cursor: pointer;
                }

            }
        }
    }

</style>
